import { Async } from "react-async";
import getData from "../Data/data";
import Skeleton from "react-loading-skeleton";

function Summary(){
    return  (
        <section>
           <h1>Summary</h1>
             <Async promiseFn={getData} endpoint={'summary'}>
             {({data, error, isPending}) => {
                if(isPending) return (<Skeleton count={3}/>)
                if(error) return `Something went wrong: ${error.message}`
                if(data) return <p>{data}</p>
                return null
             }}
             </Async>
         </section>
    );
}

export default Summary;